import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import img from '../assets/logo.png'

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Function to check if a link is active
  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  // Active link styles
  const activeStyles = "text-blue-600 border-b-2 border-blue-600";
  const inactiveStyles = "text-gray-700 hover:text-blue-600";

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to='/'>
              <img src={img} className='w-14 h-14' alt="Company Logo" />
            </Link>
            <div className="flex-shrink-0 lg:flex ms-3 items-center hidden">
              <span className="text-2xl font-bold text-blue-600">All Global Consultancy Services</span>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to='/'
              className={`font-medium transition duration-300 pb-2 ${isActiveLink('/') ? activeStyles : inactiveStyles
                }`}
            >
              Home
            </Link>
            <Link
              to='/about'
              className={`font-medium transition duration-300 pb-2 ${isActiveLink('/about') ? activeStyles : inactiveStyles
                }`}
            >
              About
            </Link>
            <Link
              to='/services'
              className={`font-medium transition duration-300 pb-2 ${isActiveLink('/services') ? activeStyles : inactiveStyles
                }`}
            >
              Services
            </Link>

                <Link
              to='/popular-visas'
              className={`font-medium transition duration-300 pb-2 ${isActiveLink('/popular-visas') ? activeStyles : inactiveStyles
                }`}
            >
              Popular Visas
            </Link>
            <Link
              to='/countries'
              className={`font-medium transition duration-300 pb-2 ${isActiveLink('/countries') ? activeStyles : inactiveStyles
                }`}
            >
              Countries
            </Link>

        

            <Link to='/contact'>
              <button className={`bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300 shadow-lg ${isActiveLink('/contact') ? 'ring-2 ring-blue-300 ring-offset-2' : ''
                }`}>
                Contact Us
              </button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 transition duration-300"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-20 left-0 right-0 bg-white shadow-lg border-t">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link
              to="/"
              className={`block px-3 py-2 rounded-lg transition duration-300 ${isActiveLink('/')
                ? 'text-blue-600 bg-blue-50 border-l-4 border-blue-600'
                : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`block px-3 py-2 rounded-lg transition duration-300 ${isActiveLink('/about')
                ? 'text-blue-600 bg-blue-50 border-l-4 border-blue-600'
                : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/services"
              className={`block px-3 py-2 rounded-lg transition duration-300 ${isActiveLink('/services')
                ? 'text-blue-600 bg-blue-50 border-l-4 border-blue-600'
                : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Services
            </Link>

                <Link
              to="/popular-visas"
              className={`block px-3 py-2 rounded-lg transition duration-300 ${isActiveLink('/popular-visas')
                  ? 'text-blue-600 bg-blue-50 border-l-4 border-blue-600'
                  : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Popular Visas
            </Link>
            <Link
              to="/countries"
              className={`block px-3 py-2 rounded-lg transition duration-300 ${isActiveLink('/countries')
                ? 'text-blue-600 bg-blue-50 border-l-4 border-blue-600'
                : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Countries
            </Link>
        

            <Link to='/contact' onClick={() => setIsMenuOpen(false)}>
              <button className="w-full text-center px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300 mt-2">
                Contact Us
              </button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
